import { render, staticRenderFns } from "./submission-agents.vue?vue&type=template&id=7e8f7179"
import script from "./submission-agents.vue?vue&type=script&lang=js"
export * from "./submission-agents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports